var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/tr/lorem/index.js
 ** module id = 1029
 ** module chunks = 0
 **/